/**
 * Service to help the PISA items work with Delivery Client via the HTML5
 * Interactive Asset custom element
 */
import ItemManager from "/js/components/ItemManager.js";

window.ACERDeliveryService = new class {
  
  constructor() {
    this.itemId = null;
  }


  listenToInteractiveAssetEvents() {
    window.ACERInteractiveAsset.listenToGetAssetData((done) => {
      // get the asset data for the current item being displayed
      var data = ItemManager.getState();
      done(JSON.parse(data));
    });
    window.ACERInteractiveAsset.listenToSetAssetData((data) => {
      if (!data) return;
      ItemManager.setState(JSON.stringify(data));
    });
  }


  listenToBodyEvents() {
    let me = this;

    $('#g-item-manager').on('continue', (e) => {
      window.ACERInteractiveAsset.emitEvent({
        type: 'goto-next',
        itemId: this.itemId
      });
    });

    $('#g-item-manager').on('goto-position', (e) => {
      let pos = e.pagePosition;

      if (pos == 'NEXT_SECTION') {
        pos = me.getTimeoutNextItem();
      }

      if (pos == -1) {
        // -1 should not happen, if it does the best thing to do it to invoke continue to next item
        window.ACERInteractiveAsset.emitEvent({
          type: 'goto-next',
          itemId: this.itemId
        });
      } else {
        window.ACERInteractiveAsset.emitEvent({
          type: 'goto-position',
          pagePosition: e.pagePosition
        });
      }
    });

    // In case we ever have to go back to previous, fire this event
    //  window.ACERInteractiveAsset.emitEvent({
    //     type: 'goto-prev',
    //     itemId: this.itemId
    //  });
  }
  
  getTimeoutNextItem() {
    let me = this;
    
    // TEMP: don't move on automatically if under reflection to workaround issue in delivery that skips to very end
    // even if there are more units
    if ( $('#task').data('progress') == 'reflect' ) {
      return -1;
    }

    for (let i=0; i < me.test[me.unit].length; i++ ) {
      let currPos = me.test[me.unit][i].items.findIndex(e => e.id == me.itemId);
      if (currPos != -1) {
        return Number(ItemManager.global['pagePosition'])+me.test[me.unit][i].items.length-currPos
      }
    }

    return -1;
  }


  fireItemLoadedEvent() {
    window.ACERInteractiveAsset.emitEvent({
      type: 'item-loaded',
      itemId: this.itemId,
      assetVersion: window.PISA2025_ASSET_VERSION
    });
  }


  iframeHasLoaded() {
    this.listenToInteractiveAssetEvents();
    this.listenToBodyEvents();
    this.fireItemLoadedEvent();
  }


  /**
   * Setup the communication between the interactive asset item and delivery
   * client
   *
   * @param {*} itemId
   */
  init(itemId, unit, test) {
    this.itemId = itemId;
    this.unit = unit;
    this.test = test;

    if (!window.frameElement) return;
    var iframeDoc = (window.frameElement.contentDocument)
      ? window.frameElement.contentDocument
      : window.frameElement.contentWindow.document;
    if (iframeDoc.readyState === 'complete') {
      this.iframeHasLoaded();
    } else {
      window.frameElement.addEventListener('load', () => {
        // we can only execute this once the iFrame load event has fired
        this.iframeHasLoaded();
      });
    }
  }
};
